// extracted by mini-css-extract-plugin
export default {"afterLogin":"SignIn_afterLogin__61zAO","verificationAppear":"SignIn_verificationAppear__69l-C"};